export const miroslawaJakubowska = {
    'mydrId': 'mirosławajakubowska',
    'firstName': 'Mirosława',
    'lastName': 'Jakubowska',
    'profession': 'Psycholog, Psychoterapeuta systemowy, Provider TRE®',
    'avatar': 'miroslawa-jakubowska.webp',
    'slug': 'psycholog-miroslawa-jakubowska',
    'locations': ['torun'],
    'services': [
        ['psychoterapy', 'children'],
        ['psychology', 'consultation']
    ]
}